import {gql} from '@apollo/client';

/**
 * Bind a device (by the short code it shows) to the signed-in parent.
 * The device, meanwhile, polls `pollDevicePairing` and receives a
 * one-time Firebase custom token once this succeeds.
 */
export const CLAIM_DEVICE_PAIRING = gql`
  mutation ClaimDevicePairing($code: String!) {
    claimDevicePairing(code: $code) {
      success
      message
    }
  }
`;
